import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';

export function CsvIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox='0 0 64 80' {...props}>
      <rect width='64' height='80' rx='8' fill='#81C784' />
      <path d='M16 34H48V38H16V34ZM16 42H48V46H16V42Z' fill='white' />
      <text x='32' y='22' textAnchor='middle' fill='white' fontSize='14' fontWeight='bold'>
        CSV
      </text>
    </SvgIcon>
  );
}
